<template>
  <div>
    <div class="d-flex" style="background-color: #eeeef0">
      <v-card
        style="border-radius: 8px; width: 200px; background-color: #eeeef0"
        elevation="0"
      >
        <v-tabs v-model="tab" style="padding: 10px 0px" vertical>
          <v-tab
            v-for="(item, index) in items"
            style="height: 36px; width: 200px"
            class="pa-0 text-capitalize py-2"
            :key="index"
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <div
                  v-bind="attrs"
                  v-on="on"
                  class="text-capitalize pl-3"
                  style="
                    width: 200px;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                    overflow: hidden;
                    text-align: left;
                  "
                >
                  {{ item.tab }}
                </div>
              </template>
              <span>{{ item.tab }}</span>
            </v-tooltip>
          </v-tab>
        </v-tabs>
      </v-card>
      <v-card
        style="flex: 1; background-color: #eeeef0; border-radius: 8px"
        class="ml-4"
        elevation="0"
      >
        <v-tabs-items v-model="tab">
          <!-- 员工信息 -->
          <v-tab-item>
            <employeemsg
            ref="employeemsg"
              :disabled="iconstatus"
              @groupChange="()=>{$emit('groupChange')}"
              @detail="(e)=>{$emit('detail',e)}"
              @changeReadonly="changeReadonly"
            ></employeemsg>
          </v-tab-item>
          <!-- 员工个人信息 -->
          <v-tab-item>
            <employeeonemsg
              :disabled="iconstatus"
              @changeReadonly="changeReadonly"
            ></employeeonemsg>
          </v-tab-item>
          <!-- 就业信息 -->
          <v-tab-item>
            <v-card>
              <v-card-text>
                <v-row>
                  <v-col cols="12" sm="6">
                    <mrc_ess_datePicker
                      @getTime="paramsChange"
                      :disabled="iconstatus"
                      :label="
                        $t('label_The_date_of_first_joining_the_company') + '*'
                      "
                      :errMsg="
                        $errors('jobslist', 'first_employment_date', [
                          {
                            rule: 'jobsbeforeDate',
                            msg: $t(
                              'verify_The_date_was_filled_in_incorrectly'
                            ),
                          },
                        ])
                      "
                      v-model="jobslist.first_employment_date"
                    ></mrc_ess_datePicker>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <!--  :errMsg="
                        $errors('jobslist', 'employment_date', [
                          {
                            rule: 'jobsCenterDate',
                            msg: $t(
                              'verify_The_date_was_filled_in_incorrectly'
                            ),
                          },
                        ])
                      " -->
                    <mrc_ess_datePicker
                      @getTime="paramsChange"
                      :disabledTwo="Boolean(jobslist.employment_date)"
                      :disabled="iconstatus"
                      :label="
                        $t('label_Thedate_of_recent_joining_the_company') + '*'
                      "
                      v-model="jobslist.employment_date"
                    ></mrc_ess_datePicker>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <!--   :errMsg="
                        $errors('jobslist', 'probation_end_date', [
                          {
                            rule: 'jobsafterDate',
                            msg: $t(
                              'verify_The_date_was_filled_in_incorrectly'
                            ),
                          },
                        ])
                      " -->
                    <mrc_ess_datePicker
                      @getTime="paramsChange"
                      :disabledTwo="Boolean(jobslist.probation_end_date)"
                      :disabled="iconstatus"
                      :label="
                        $t('label_The_end_date_of_the_trial_period') + '*'
                      "
                      v-model="jobslist.probation_end_date"
                    ></mrc_ess_datePicker>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <!-- termination_effective_date  termination_notification_date -->
                    <mrc_ess_datePicker
                      @getTime="paramsChange"
                      disabledTwo
                      :disabled="iconstatus"
                      :label="$t('label_The_date_of_separation') + '*'"
                      v-model="jobslist.termination_effective_date"
                    ></mrc_ess_datePicker>
                  </v-col>
                </v-row>
              </v-card-text>
              <mrc_ess_submitBtn
                @success="datesuccess"
                @cancel="datecancel"
                :loading="btnIsLoading"
                v-if="!iconstatus"
              ></mrc_ess_submitBtn>
            </v-card>
          </v-tab-item>
          <!-- 银行信息 -->
          <v-tab-item>
            <v-card>
              <v-card-text class="tableBoxComponent">
                <v-data-table
                  :headers="headers"
                  :items="blanklist"
                  sort-by="calories"
                  hide-default-footer
                  @click:row="godetail"
                >
                  <template v-slot:no-data>
                    <mrc_ess_noContent :no_data_text="$t('label_blank')" />
                  </template>
                  <template v-slot:item.status="{ item }">
                    <!-- <mrc_ess_chip
                      rounded
                      color="green"
                      dark
                      small
                      v-if="item.status == 1"
                      >{{ $t('label_To_enable_the') }}</mrc_ess_chip
                    >
                    <mrc_ess_chip rounded color="red" dark small v-else>{{
                      $t('label_disable')
                    }}</mrc_ess_chip> -->
                    <mrc_ess_viewbtn :is_used="item.status"></mrc_ess_viewbtn>
                  </template>

                  <template v-slot:item.actions="{ item }" v-if="!iconstatus">
                    <v-icon class="mr-4" @click="editItem(item)"
                      >mdi-pencil</v-icon
                    >
                    <v-icon @click="deleteItem(item)">mdi-delete</v-icon>
                  </template>

                  <template v-slot:footer>
                    <v-divider></v-divider>
                    <mrc_ess_textAddBtn
                      v-if="!iconstatus"
                      :rounded="false"
                      depressed
                      @click="editItem"
                      :text="$t('label_New_bank_account')"
                    ></mrc_ess_textAddBtn>
                    <!-- <span v-if="!iconstatus"
                          class="mt-2 pb-2 d-flex ml-5"
                          @click="editItem">
                      <span :style="{'color': $vuetify.theme.defaults.light.primary,'line-height': '28px','font-size':'14px'}">{{$t('label_New_bank_account')}}</span>
                      <v-icon class="material-icons"
                              :style="{'color':$vuetify.theme.defaults.light.primary,'font-size':'24px'}">add</v-icon>
                    </span> -->
                  </template>
                </v-data-table>
              </v-card-text>
              <mrc_ess_submitBtn
                @success="blanksuccess"
                @cancel="blankcancel"
                :loading="btnIsLoading"
                v-if="!iconstatus"
              >
              </mrc_ess_submitBtn>
            </v-card>
          </v-tab-item>
          <!-- 紧急联系人 -->
          <v-tab-item>
            <v-card>
              <v-card-text>
                <div v-if="!iconstatus" style="height: 36px">
                  <mrc_ess_textAddBtn
                    :textstatus="false"
                    color="white"
                    @click="editItemtel"
                    left
                    style="position: absolute; right: 32px"
                    :text="$t('label_New_emergency_contact')"
                  ></mrc_ess_textAddBtn>
                </div>
                <v-card
                  v-for="(item, index) in tellist"
                  :key="index"
                  class="mt-2"
                  style="border: 1px solid #eeeef0"
                >
                  <v-card-text>
                    <div class="telheader">
                      <span class="text-h5 text--secondary"
                        >{{ $t("label_Emergency_contact")
                        }}{{ index + 1 }}</span
                      >
                      <div v-if="!iconstatus">
                        <v-icon class="mr-4" @click="editItemtel(item)">
                          mdi-pencil
                        </v-icon>
                        <v-icon @click="deleteItemtel(item)">
                          mdi-delete
                        </v-icon>
                      </div>
                    </div>
                    <v-row>
                      <v-col cols="12" sm="6">
                        <mrc_ess_multiText
                          :label="$t('label_Relationship') + '*'"
                          :readonly="true"
                          :isNational="
                            judegNational('emergency_contact_relationship')
                          "
                          v-model="item.emergency_contact_relationship"
                        >
                        </mrc_ess_multiText>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <mrc_ess_multiText
                          :label="$t('label_all_people') + '*'"
                          :isNational="
                            judegNational('emergency_contact_full_name')
                          "
                          :readonly="true"
                          v-model="item.emergency_contact_full_name"
                        >
                        </mrc_ess_multiText>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <mrc_ess_phoneInput
                          :readonly="true"
                          v-model="item.emergency_contact_phone_number"
                          :changeCode.sync="item.emergency_contact_area_code"
                          :code="item.emergency_contact_area_code"
                        >
                        </mrc_ess_phoneInput>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <mrc_ess_multiText
                          :label="$t('label_Mailbox')"
                          :isNational="judegNational('emergency_contact_email')"
                          :readonly="true"
                          v-model="item.emergency_contact_email"
                        >
                        </mrc_ess_multiText>
                      </v-col>
                      <v-col cols="12">
                        <mrc_ess_multiText
                          :label="$t('label_The_mailing_address')"
                          :readonly="true"
                          v-model="item.emergency_contact_address_line_1"
                        >
                        </mrc_ess_multiText>
                      </v-col>
                      <v-col cols="12" class="mt-n6">
                        <mrc_ess_multiText
                          :readonly="true"
                          v-model="item.emergency_contact_address_line_2"
                        >
                        </mrc_ess_multiText>
                      </v-col>
                      <v-col cols="12" class="mt-n6">
                        <mrc_ess_multiText
                          :readonly="true"
                          v-model="item.emergency_contact_address_line_3"
                        >
                        </mrc_ess_multiText>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-card-text>
              <mrc_ess_submitBtn
                @success="telsuccess"
                @cancel="telcancel"
                :loading="btnIsLoading"
                v-if="!iconstatus"
              >
              </mrc_ess_submitBtn>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </div>

    <!-- 紧急联系人弹出框 -->
    <mrc_ess_myDialog
      v-model="dialog2"
      :title="$t('label_New_emergency_contact')"
      :width="800"
      @success="telsave"
      @cancel="telclose"
    >
      <v-card-text class="pa-0">
        <v-row>
          <v-col cols="12">
            <mrc_ess_multiText
              :label="$t('label_Relationship') + '*'"
              :isNational="judegNational('emergency_contact_relationship')"
              :readonly="iconstatus"
              :error-messages="
                $errors(
                  'editedtelItem',
                  'emergency_contact_relationship',
                  requiredRule.concat(nocharacter)
                )
              "
              v-model="editedtelItem.emergency_contact_relationship"
            >
            </mrc_ess_multiText>
          </v-col>
          <v-col cols="12">
            <!-- :error-messages="$errors('editedtelItem','emergency_contact_full_name',requiredRule.concat(nocharacter))" -->
            <mrc_ess_multiText
              :label="$t('label_all_people') + '*'"
              :isNational="judegNational('emergency_contact_full_name')"
              :error-messages="
                $errors(
                  'editedtelItem',
                  'emergency_contact_full_name',
                  requiredRule.concat(nocharacter)
                )
              "
              :readonly="iconstatus"
              v-model="editedtelItem.emergency_contact_full_name"
            >
            </mrc_ess_multiText>
          </v-col>
          <v-col cols="12" sm="6">
            <mrc_ess_phoneInput
              :readonly="iconstatus"
              :codeErrMsg="
                $errors(
                  'editedtelItem',
                  'emergency_contact_area_code',
                  requiredRule
                )
              "
              :error-messages="
                $errors(
                  'editedtelItem',
                  'emergency_contact_phone_number',
                  requiredRule
                )
              "
              v-model="editedtelItem.emergency_contact_phone_number"
              :changeCode.sync="editedtelItem.emergency_contact_area_code"
              :code="editedtelItem.emergency_contact_area_code"
            >
            </mrc_ess_phoneInput>
          </v-col>
          <v-col cols="12" sm="6">
            <mrc_ess_multiText
              :label="$t('label_Mailbox')"
              :isNational="judegNational('emergency_contact_email')"
              :error-messages="
                $errors('editedtelItem', 'emergency_contact_email', emailRule)
              "
              :readonly="iconstatus"
              v-model="editedtelItem.emergency_contact_email"
            >
            </mrc_ess_multiText>
          </v-col>
          <v-col cols="12">
            <mrc_ess_multiText
              :label="$t('label_The_mailing_address')"
              :isNational="judegNational('emergency_contact_address_line_1')"
              :readonly="iconstatus"
              v-model="editedtelItem.emergency_contact_address_line_1"
            >
            </mrc_ess_multiText>
          </v-col>
          <v-col cols="12">
            <mrc_ess_multiText
              class="mt-n6"
              :isNational="judegNational('emergency_contact_address_line_2')"
              :readonly="iconstatus"
              v-model="editedtelItem.emergency_contact_address_line_2"
            >
            </mrc_ess_multiText>
          </v-col>
          <v-col cols="12">
            <mrc_ess_multiText
              class="mt-n6"
              :isNational="judegNational('emergency_contact_address_line_3')"
              :readonly="iconstatus"
              v-model="editedtelItem.emergency_contact_address_line_3"
            >
            </mrc_ess_multiText>
          </v-col>
        </v-row>
      </v-card-text>
    </mrc_ess_myDialog>

    <!-- 银行弹出框 -->
    <mrc_ess_myDialog
      v-model="dialog"
      :title="$t('label_New_bank_account')"
      width="70vw"
      @success="save"
      @cancel="close"
    >
      <v-card-text class="pa-0">
        <v-row>
          <v-col cols="12">
            <mrc_ess_multiText
              v-model="editedItem.bank_name"
              :isNational="judegNational('bank_name')"
              @input="$v.editedItem.bank_name.$touch()"
              :error-messages="
                $errors(
                  'editedItem',
                  'bank_name',
                  requiredRule.concat(nocharacter)
                )
              "
              :label="$t('label_The_name_of_the_bank') + '*'"
            ></mrc_ess_multiText>
          </v-col>
          <v-col cols="12">
            <mrc_ess_multiText
              v-model="editedItem.bank_account_number"
              :isNational="judegNational('bank_account_number')"
              @input="$v.editedItem.bank_account_number.$touch()"
              :error-messages="
                $errors(
                  'editedItem',
                  'bank_account_number',
                  requiredRule.concat(numericRule)
                )
              "
              :label="$t('label_Account_number') + '*'"
            ></mrc_ess_multiText>
          </v-col>
          <v-col cols="12">
            <mrc_ess_multiText
              v-model="editedItem.bank_account_holder_name"
              :isNational="judegNational('bank_account_holder_name')"
              :error-messages="
                $errors(
                  'editedItem',
                  'bank_account_holder_name',
                  requiredRule.concat(nocharacter)
                )
              "
              :label="$t('label_Register_name') + '*'"
            ></mrc_ess_multiText>
          </v-col>
          <v-col cols="12" class="d-flex">
            <mrc_ess_datePicker
              @getTime="paramsChange"
              :disabled="false"
              :errMsg="
                $errors(
                  'editedItem',
                  'effective_start_date',
                  requiredRule.concat([
                    {
                      rule: 'beforeDate',
                      msg: $t('verify_cannot_exceed_the_expiration_date'),
                    },
                  ])
                )
              "
              :label="$t('label_effective_start_date') + '*'"
              v-model="editedItem.effective_start_date"
            >
            </mrc_ess_datePicker>
            <!-- </v-col> -->
            <div class="d-flex align-center justify-center">
              <v-icon class="material-icons">keyboard_arrow_right</v-icon>
            </div>
            <!-- <v-col cols="5.5"> -->
            <mrc_ess_datePicker
              @getTime="paramsChange"
              afterDate
              :label="$t('label_effective_end_date') + '*'"
              :disabled="false"
              :errMsg="
                $errors(
                  'editedItem',
                  'effective_end_date',
                  requiredRule.concat([
                    {
                      rule: 'afterDate',
                      msg: $t('verify_no_later_than_the_start_time'),
                    },
                  ])
                )
              "
              v-model="editedItem.effective_end_date"
            >
            </mrc_ess_datePicker>
          </v-col>
        </v-row>
      </v-card-text>
    </mrc_ess_myDialog>
  </div>
</template>

<script>
import employeemsg from "./employeemsg";
import employeeonemsg from "./employeeone_msg";
import {
  required,
  maxLength,
  between,
  email,
  url,
  numeric,
} from "vuelidate/lib/validators";
import {
  getStaffTelUpdate,
  getStaffTelList,
  getStaffBankUpdate,
  getStaffBank,
  getStaffJobDetail,
  getStaffJobUpdate,
} from "@/service/api/staffmsg.js";
import moment from "moment";
import clientIntVue from "../../internationalization/client-internationalization/clientInt.vue";
export default {
  components: {
    employeemsg,
    employeeonemsg,
  },
  props: {
    iconstatus: {
      type: Boolean,
    },
  },
  data() {
    return {
      skeletonloading: true,
      btnIsLoading: false,
      dialog2: false,
      dialog: false,
      disabled: false,
      stafflist: "",
      tab: 0,
      jobslist: {
        staff_uuid: "", //关联staff表uuid
        first_employment_date: null, //第一次加入公司时间
        employment_date: null, //最近加入公司时间
        probation_end_date: null, //试用结束日期
        termination_effective_date: null, //离职通知日期
        termination_effective_date: null, //离职生效日期(只读)
      },
      blanklist: [
        {
          staff_bank_account_id: 11, //物理主键
          uuid: "", //唯一标识
          staff_uuid: "", //关联staff表uuid
          bank_name: "", //开户行名称
          bank_account_number: "", //银行卡号码
          bank_account_holder_name: "", //登记名称
        },
      ],
      deleteblanklist: [], //删除银行列表
      editedIndex: -1,
      editedItem: {
        bank_name: "", //开户行名称
        bank_account_number: "", //银行卡号码
        bank_account_holder_name: "", //登记名称
        effective_start_date: "",
        effective_end_date: "",
      },
      defaultItem: {
        bank_name: "", //开户行名称
        bank_account_number: "", //银行卡号码
        bank_account_holder_name: "", //登记名称
        effective_start_date: "",
        effective_end_date: "",
      },
      tellist: [
        // {
        //   staff_emergency_contact_info_id: '',
        //   uuid: '',
        //   staff_uuid: '',
        //   emergency_contact_relationship: '',
        //   emergency_contact_family_name: '',
        //   emergency_contact_given_name: '',
        //   emergency_contact_christian_name: '',
        //   emergency_contact_area_code: '',
        //   emergency_contact_phone_number: '',
        //   emergency_contact_email: '',
        //   emergency_contact_address_line_1: '',
        //   emergency_contact_address_line_2: '',
        //   emergency_contact_address_line_3: '',
        //   phone_number: '' //自己拼接的参数 视图显示
        // },
      ], //紧急联系人列表
      deletetellist: [], //删除紧急联系人列表
      editedtelIndex: -1,
      editedtelItem: {
        emergency_contact_relationship: "",
        emergency_contact_full_name: "",
        // emergency_contact_given_name: '',
        // emergency_contact_family_name: '',
        // emergency_contact_christian_name: '',
        emergency_contact_area_code: "",
        emergency_contact_phone_number: "",
        emergency_contact_email: "",
        emergency_contact_address_line_1: "",
        emergency_contact_address_line_2: "",
        emergency_contact_address_line_3: "",
      },
      defaulteltItem: {
        emergency_contact_relationship: "",
        emergency_contact_full_name: "",
        // emergency_contact_given_name: '',
        // emergency_contact_family_name: '',
        // emergency_contact_christian_name: '',
        emergency_contact_area_code: "",
        emergency_contact_phone_number: "",
        emergency_contact_email: "",
        emergency_contact_address_line_1: "",
        emergency_contact_address_line_2: "",
        emergency_contact_address_line_3: "",
      },
    };
  },
  created() {},
  async mounted() {
    await this.national("mrbase_sys_staff_employment_info");
    // await this.national('mrbase_sys_staff_bank_account')
    // await this.national('mrbase_sys_staff_emergency_contact_info')
    this.getjoblist();
    this.getblanklist();
    this.gettellist();
  },
  methods: {
    changeReadonly() {
      this.$emit("changeReadonly");
    },
    async getjoblist() {
      this.skeletonloading = true;
      const uuid = this.$store.state.uuid;
      const res = await getStaffJobDetail({
        staff_uuid: uuid,
      });
      if (res.code == 200) {
        this.jobslist = res.data;
      }
      this.skeletonloading = false;
    },
    async getblanklist() {
      this.skeletonloading = true;
      const uuid = this.$store.state.uuid;
      const res = await getStaffBank({
        staff_uuid: uuid,
      });
      if (res.code == 200) {
        this.blanklist = res.data;
      }
      this.skeletonloading = false;
    },
    async gettellist() {
      this.skeletonloading = true;
      const uuid = this.$store.state.uuid;
      const res = await getStaffTelList({
        staff_uuid: uuid,
      });
      if (res.code == 200) {
        this.tellist = this.$deletefield(res.data);
        // this.tellist = this.$deletefield(res.data).map((item) => {
        //   item['phone_number'] =
        //     '+' +
        //     item.emergency_contact_area_code +
        //     '\xa0' +
        //     item.emergency_contact_phone_number
        //   return item
        // })
      }
      this.skeletonloading = false;
    },
    paramsChange() {},
    datesuccess() {
      //员工就业信息提交数据
      //  moment(time).format('YYYY-MM-DD')
      this.$v.jobslist.$touch();
      if (this.$v.jobslist.$error) return;
      this.btnIsLoading = true;
      this.jobslist.staff_uuid = this.$store.state.uuid;
      for (const key in this.jobslist) {
        if (key.includes("date")) {
          if (this.jobslist[key]) {
            this.jobslist[key] = moment(this.jobslist[key]).format(
              "YYYY-MM-DD"
            );
          } else {
            delete this.jobslist[key];
          }
        }
      }
      getStaffJobUpdate(this.jobslist).then(async (res) => {
        if (res.code == 200) {
          this.$Message({
            text: this.$t("message_The_operation_was_successful"),
          });
          await this.getjoblist();
          this.$emit("changeReadonly");
        }
        this.btnIsLoading = false;
      });
    },
    blanksuccess() {
      //银行信息提交
      this.btnIsLoading = true;
      const uuid = this.$store.state.uuid;
      const detailuuid = this.$store.state.detailuuid;
      this.blanklist.map((item) => {
        delete item.created_by;
        delete item.created_utc_datetime;
        delete item.updated_by;
        delete item.updated_utc_datetime;
        if (!item.status) item.status = 1;
        if (item.effective_start_date || item.effective_end_date) {
          item.effective_start_date = moment(item.effective_start_date).format(
            "YYYY-MM-DD"
          );
          item.effective_end_date = moment(item.effective_end_date).format(
            "YYYY-MM-DD"
          );
        } else {
          delete item.effective_start_date;
          delete item.effective_end_date;
        }
      });
      getStaffBankUpdate({
        uuid,
        user_id: detailuuid,
        mrbase_sys_staff_bank_account: [
          ...this.blanklist,
          ...this.deleteblanklist,
        ],
      }).then(async (res) => {
        if (res.code == 200) {
          this.$Message({
            text: this.$t("message_The_operation_was_successful"),
          });
          await this.getblanklist();
          this.$emit("changeReadonly");
          this.btnIsLoading = false;
        }
      });
    },
    async blankcancel() {
      await this.getblanklist();
      this.$emit("changeReadonly");
      // this.$myConfirm({
      //   content: this.$t('message_Confirm_the_cancellation_of_the_edit'),
      // })
      //   .then((res) => {
      //     this.$router.push({
      //       name: 'staffmanagement',
      //     })
      //   })
      //   .catch((err) => { })
    },
    telsuccess() {
      //紧急联系人提交
      this.btnIsLoading = true;
      const uuid = this.$store.state.uuid;
      const user_id = this.$store.state.detailuuid;
      const mrbase_sys_staff_emergency_contact_info = this.$clone(this.tellist);
      // const mrbase_sys_staff_emergency_contact_info = this.tellist.map(
      //   (item) => {
      //     delete item.phone_number
      //     return item
      //   }
      // )
      getStaffTelUpdate({
        uuid,
        user_id,
        mrbase_sys_staff_emergency_contact_info: [
          ...this.deletetellist,
          ...mrbase_sys_staff_emergency_contact_info,
        ],
      }).then(async (res) => {
        if (res.code == 200) {
          this.$Message({
            text: this.$t("message_The_operation_was_successful"),
          });
          await this.gettellist();
          this.$emit("changeReadonly");
        }
        this.btnIsLoading = false;
      });
    },
    async telcancel() {
      await this.gettellist();
      this.$emit("changeReadonly");
      // this.$myConfirm({
      //   content: this.$t('message_Confirm_the_cancellation_of_the_edit'),
      // })
      //   .then((res) => {
      //     this.$router.push({
      //       name: 'staffmanagement',
      //     })
      //   })
      //   .catch((err) => { })
    },
    async datecancel() {
      await this.getjoblist();
      this.$emit("changeReadonly");
      // this.$myConfirm({
      //   content: this.$t('message_Confirm_the_cancellation_of_the_edit'),
      // })
      //   .then((res) => {
      //     this.$router.push({
      //       name: 'staffmanagement',
      //     })
      //   })
      //   .catch((err) => { })
    },
    godetail() {},
    editItem(item) {
      //传了item就是修改  没传就是添加  默认传了事件对象。。
      this.$v.editedItem.$reset();
      if (
        item.staff_uuid ||
        item.staff_uuid ||
        item.bank_name ||
        item.bank_account_number
      ) {
        this.editedIndex = this.blanklist.indexOf(item);
        // console.log(this.blanklist, item, this.blanklist.indexOf(item));
        this.editedItem = Object.assign({}, item);
      }
      this.dialog = true;
    },

    deleteItem(item) {
      const index = this.blanklist.indexOf(item);
      // console.log(this.blanklist.indexOf(item));
      this.$myConfirm({
        content: this.$t("message_Confirm_the_deletion"),
      }).then(() => {
        const dd = this.blanklist.splice(index, 1);
        if (dd[0].uuid || dd[0].staff_uuid)
          this.deleteblanklist.push({ uuid: dd[0].uuid, "~type~": "del" });
      });
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    save() {
      //银行弹出框保存
      this.$v.editedItem.$touch();
      if (this.$v.editedItem.$error) return;
      if (this.editedIndex > -1) {
        Object.assign(this.blanklist[this.editedIndex], this.editedItem);
      } else {
        // console.log(this.editedItem);
        this.blanklist.push({ ...this.editedItem, status: 1 });
      }
      this.close();
    },
    telsave() {
      //紧急联系人 电话弹出框
      this.$v.editedtelItem.$touch();
      if (this.$v.editedtelItem.$error) return;
      if (this.editedtelIndex > -1) {
        Object.assign(this.tellist[this.editedtelIndex], this.editedtelItem);
      } else {
        // console.log(this.editedtelItem);
        this.tellist.push(this.editedtelItem);
      }
      this.telclose();
    },
    telclose() {
      this.dialog2 = false;
      this.$nextTick(() => {
        this.editedtelItem = Object.assign({}, this.defaulteltItem);
        this.editedtelIndex = -1;
      });
    },
    editItemtel(item) {
      //紧急联系人
      this.$v.editedtelItem.$reset();
      if (item.uuid || item.staff_uuid || item.emergency_contact_relationship) {
        this.editedtelIndex = this.tellist.indexOf(item);
        this.editedtelItem = Object.assign({}, item);
      }
      this.dialog2 = true;
    },
    deleteItemtel(item) {
      const index = this.tellist.indexOf(item);
      this.$myConfirm({
        content: this.$t("message_Confirm_the_deletion"),
      }).then(() => {
        const dd = this.tellist.splice(index, 1);
        if (dd[0].uuid || dd[0].staff_uuid)
          this.deletetellist.push({ uuid: dd[0].uuid, "~type~": "del" });
        // console.log(this.deletetellist);
      });
    },
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t("label_The_name_of_the_bank"),
          align: "start",
          sortable: false,
          value: "bank_name",
        },
        {
          text: this.$t("label_Account_number"),
          align: "start",
          sortable: false,
          value: "bank_account_number",
        },
        {
          text: this.$t("label_Register_name"),
          align: "start",
          sortable: false,
          value: "bank_account_holder_name",
        },
        {
          text: this.$t("label_state"),
          align: "start",
          sortable: false,
          value: "status",
        },
        {
          align: "end",
          sortable: false,
          value: "actions",
        },
      ];
    },
    items() {
      return [
        { tab: this.$t("label_employee_information") },
        { tab: this.$t("label_Employee_personal_information") },
        { tab: this.$t("label_Employee_employment_information") },
        { tab: this.$t("label_Employee_bank_information") },
        { tab: this.$t("label_Employee_emergency_contact") },
      ];
    },
  },
  watch: {},
  validations: {
    editedItem: {
      bank_name: {
        required,
        nocharacter(value) {
          return this.$myVerify.nocharacter(this.INT(value));
        },
      },
      bank_account_number: {
        required,
        numeric,
      },
      bank_account_holder_name: {
        required,
        nocharacter(value) {
          return this.$myVerify.nocharacter(this.INT(value));
        },
      },
      effective_start_date: {
        required,
        beforeDate(value) {
          if (!this.editedItem.effective_end_date) return true;
          const prevData = new Date(value).valueOf();
          const nextData = new Date(
            this.editedItem.effective_end_date
          ).valueOf();
          return prevData < nextData;
        },
      },
      effective_end_date: {
        required,
        afterDate(value) {
          if (!this.editedItem.effective_start_date) return true;
          const nextData = new Date(value).valueOf();
          const prevData = new Date(
            this.editedItem.effective_start_date
          ).valueOf();
          return prevData < nextData;
        },
      },
    },
    editedtelItem: {
      emergency_contact_relationship: {
        required,
        nocharacter(value) {
          return this.$myVerify.nocharacter(this.INT(value));
        },
      },
      emergency_contact_full_name: {
        required,
        nocharacter(value) {
          return this.$myVerify.nocharacter(this.INT(value));
        },
      },
      emergency_contact_family_name: {
        // required,
        // nocharacter (value) {
        //   return this.$myVerify.nocharacter(this.INT(value))
        // },
      },
      emergency_contact_christian_name: {
        // required,
        // nocharacter (value) {
        //   return this.$myVerify.nocharacter(this.INT(value))
        // },
      },
      emergency_contact_area_code: {
        required,
      },
      emergency_contact_phone_number: {
        required,
        // areaRequired (value) {
        //   if (value) {
        //     return this.editedtelItem.emergency_contact_area_code ? true : false
        //   } else {
        //     return true
        //   }
        // },
        // phoneVerify (value) {
        //   if (!value)
        //     return true
        //   const regex = this.$myVerify.phone
        //   return regex.test(this.editedtelItem.emergency_contact_area_code + value)
        // }
      },
      emergency_contact_email: {
        email,
      },
      emergency_contact_address_line_1: {},
      emergency_contact_address_line_2: {},
      emergency_contact_address_line_3: {},
    },
    jobslist: {
      first_employment_date: {
        jobsbeforeDate(value) {
          if (
            !this.jobslist.first_employment_date &&
            !this.jobslist.probation_end_date
          )
            return true;
          const onedate = new Date(value).valueOf();
          const twodate = new Date(this.jobslist.employment_date).valueOf();
          const threedate = new Date(
            this.jobslist.probation_end_date
          ).valueOf();
          return (
            threedate >= onedate && threedate >= twodate && onedate <= twodate
          );
        },
      },
      employment_date: {
        // jobsCenterDate (value) {
        //   if (
        //     !this.jobslist.first_employment_date &&
        //     !this.jobslist.probation_end_date
        //   )
        //     return true
        //   const onedate = new Date(
        //     this.jobslist.first_employment_date
        //   ).valueOf()
        //   const twodate = new Date(value).valueOf()
        //   const threedate = new Date(this.jobslist.probation_end_date).valueOf()
        //   return (
        //     threedate >= onedate && threedate >= twodate && onedate <= twodate
        //   )
        // },
      },
      probation_end_date: {
        // jobsafterDate (value) {
        //   if (
        //     !this.jobslist.employment_date &&
        //     !this.jobslist.first_employment_date
        //   )
        //     return true
        //   const onedate = new Date(
        //     this.jobslist.first_employment_date
        //   ).valueOf()
        //   const twodate = new Date(this.jobslist.employment_date).valueOf()
        //   const threedate = new Date(value).valueOf()
        //   return (
        //     threedate >= onedate && threedate >= twodate && onedate <= twodate
        //   )
        // },
      },
    },
  },
};
</script>

<style scoped>
/* .v-tabs--vertical > .v-tabs-bar .v-tab {
  height: 36px;
}
.v-tabs--vertical > .v-tabs-bar .v-tabs-slider {
  height: 36px;
  width: 4px;
}
.v-tab--active {
  background-color: rgb(229, 238, 255) !important;
}
/deep/ .v-tabs--vertical .v-tabs-bar__content {
  padding: 16px 0;
} */
/deep/ .v-slide-group__wrapper {
  padding: 8px 0px;
}
/deep/ .v-tab--active {
  background-color: rgb(229, 238, 255) !important;
}
.v-tabs--vertical > .v-tabs-bar .v-tab {
  height: 36px;
}
.v-tabs--vertical > .v-tabs-bar .v-tabs-slider {
  height: 36px;
  width: 4px;
}
/deep/ .v-slide-group__content {
  white-space: normal !important;
}
.telheader {
  display: flex;
  align-content: center;
  justify-content: space-between;
}
.tableBoxComponent
  /deep/
  .v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr
  > td {
  padding: 8px 16px;
}
</style>
